import React from 'react'
import VendorTable from '../../components/Vendor/VendorTable'

export const VendorPage = () => {
  return (
    <div>
        <VendorTable/>
    </div>
  )
}
